export function recursivelyTransformValues<S extends object, T>(
  element: unknown,
  predicate: (v: object) => v is S,
  transform: (pv: S) => T,
): unknown {
  if (Array.isArray(element)) {
    return element.map((el) => recursivelyTransformValues(el, predicate, transform));
  }
  if (typeof element === 'object' && element !== null) {
    if (predicate(element)) {
      return transform(element);
    }
    // Pass through class instances unchanged (e.g. Uint8Array)
    if (Object.getPrototypeOf(element).constructor !== Object) {
      return element;
    }
    const transformedElement: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(element)) {
      transformedElement[key] = recursivelyTransformValues(value, predicate, transform);
    }
    return transformedElement;
  }
  return element;
}
